import { render, staticRenderFns } from "./SociosLista.vue?vue&type=template&id=1da69a3c&"
import script from "./SociosLista.vue?vue&type=script&lang=js&"
export * from "./SociosLista.vue?vue&type=script&lang=js&"
import style0 from "./SociosLista.vue?vue&type=style&index=0&id=1da69a3c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports